import React from 'react'
import { Box, Typography } from '@mui/material'
import { ImageNotSupported } from '@mui/icons-material'

interface ImagePlaceholderProps {
    title?: string
}

const ImagePlaceholder: React.FC<ImagePlaceholderProps> = ({ title = 'No image available' }) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: 'auto',
                minHeight: '30vh',
                bgcolor: 'grey.100',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 1,
                aspectRatio: '16/9'
            }}
        >
            <ImageNotSupported
                sx={{
                    fontSize: { xs: 40, md: 48 },
                    color: 'grey.400'
                }}
            />
            <Typography
                variant="body2"
                sx={{
                    color: 'grey.500',
                    fontSize: { xs: '0.75rem', md: '0.875rem' },
                    fontWeight: 500
                }}
            >
                {title}
            </Typography>
        </Box>
    )
}

export { ImagePlaceholder }
export type { ImagePlaceholderProps }
